module.exports = __webpack_public_path__ + "pc/img/work.3109b5a4.jpg";